import React from 'react';
import AixueHeader from '@/components/AixueHeader/index';
import styles from './index.module.scss';
import textgroupSrc from '@/assets/aixuejoin-textgroup.png';

export default function Screen1() {
  return (
    <section className={styles['screen1-cover']}>
      {/* 头部导航 */}
      <div className={styles['screen1-header']}>
        <AixueHeader title="爱学" />
      </div>

      <div className={styles['screen1-wrap']}>
        <div  className={styles['screen1-content']}>
          <div>
            <img
              className={styles['screen1-titleImg']}
              src={textgroupSrc}
              alt="加入爱学"
            />
          </div>
          <div className={styles['screen1-desc']}>投身AI，重塑教育</div>
        </div>
      </div>
    </section>
  );
}
